/**
 * @generated SignedSource<<4271fd5d90beb048446d40ce281eec9b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AnalyticsTimeResolution = "DAY" | "MONTH" | "QUARTER" | "WEEK";
export type AnalyticsValueUnit = "duration" | "percentage" | "unit";
export type WorkspaceAnalyticsDimensionType = "STORE" | "WORKSPACE_OWNER";
export type WorkspaceAnalyticsMetric = "PRODUCT_DATE_TRACKER_REGISTERED" | "PRODUCT_DATE_TRACKER_TASKS_COMPLETED" | "ROUTINE_OCCASION_COMPLETED" | "TASK_EXECUTIONS_COMPLETED" | "TODO_CREATED" | "TODO_ISSUE_CREATED" | "TODO_ISSUE_RESOLVED" | "TODO_ISSUE_RESOLVED_AVG_TIME" | "TODO_RESOLVED" | "TODO_RESOLVED_AVG_TIME";
export type WorkspaceAnalyticsDetailQuery$variables = {
  groupByDimension: WorkspaceAnalyticsDimensionType;
  metric: WorkspaceAnalyticsMetric;
  timeResolution: AnalyticsTimeResolution;
  workspaceId: string;
};
export type WorkspaceAnalyticsDetailQuery$data = {
  readonly workspace: {
    readonly analytics: {
      readonly connection: {
        readonly " $fragmentSpreads": FragmentRefs<"TimeSeriesChartAndTable_data">;
      };
      readonly valueUnit: AnalyticsValueUnit;
    } | null;
  };
};
export type WorkspaceAnalyticsDetailQuery = {
  response: WorkspaceAnalyticsDetailQuery$data;
  variables: WorkspaceAnalyticsDetailQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupByDimension"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "metric"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "timeResolution"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "workspaceId"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "metric",
    "variableName": "metric"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "valueUnit",
  "storageKey": null
},
v7 = [
  {
    "kind": "Variable",
    "name": "groupByDimension",
    "variableName": "groupByDimension"
  },
  {
    "kind": "Variable",
    "name": "timeResolution",
    "variableName": "timeResolution"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceAnalyticsDetailQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v4/*: any*/),
          "concreteType": "Workspace",
          "kind": "LinkedField",
          "name": "workspace",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": (v5/*: any*/),
              "concreteType": "WorkspaceTimeSeriesAnalytics",
              "kind": "LinkedField",
              "name": "analytics",
              "plural": false,
              "selections": [
                (v6/*: any*/),
                {
                  "alias": null,
                  "args": (v7/*: any*/),
                  "concreteType": "TimeSeriesAnalyticsConnection",
                  "kind": "LinkedField",
                  "name": "connection",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "TimeSeriesChartAndTable_data"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "WorkspaceAnalyticsDetailQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "WorkspaceTimeSeriesAnalytics",
            "kind": "LinkedField",
            "name": "analytics",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "TimeSeriesAnalyticsConnection",
                "kind": "LinkedField",
                "name": "connection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TimeSeriesAnalyticsNodeDimension",
                    "kind": "LinkedField",
                    "name": "dimensions",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "label",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "color",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TimeSeriesAnalyticsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TimeSeriesAnalyticsNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "date",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "formattedDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TimeSeriesAnalyticsNodeDimensionValue",
                            "kind": "LinkedField",
                            "name": "values",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "dimensionId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "value",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b0e8bbfb9012a33439a725f5be4d1d90",
    "id": null,
    "metadata": {},
    "name": "WorkspaceAnalyticsDetailQuery",
    "operationKind": "query",
    "text": "query WorkspaceAnalyticsDetailQuery(\n  $workspaceId: ID!\n  $metric: WorkspaceAnalyticsMetric!\n  $groupByDimension: WorkspaceAnalyticsDimensionType!\n  $timeResolution: AnalyticsTimeResolution!\n) {\n  workspace(id: $workspaceId) {\n    analytics(metric: $metric) {\n      valueUnit\n      connection(groupByDimension: $groupByDimension, timeResolution: $timeResolution) {\n        ...TimeSeriesChartAndTable_data\n      }\n    }\n    id\n  }\n}\n\nfragment TimeSeriesChart on TimeSeriesAnalyticsConnection {\n  dimensions {\n    id\n    label\n    color\n  }\n  edges {\n    node {\n      date\n      formattedDate\n      values {\n        dimensionId\n        value\n      }\n    }\n  }\n}\n\nfragment TimeSeriesChartAndTable_data on TimeSeriesAnalyticsConnection {\n  ...TimeSeriesChart\n  ...TimeSeriesTable\n  dimensions {\n    id\n  }\n}\n\nfragment TimeSeriesTable on TimeSeriesAnalyticsConnection {\n  dimensions {\n    id\n    label\n    color\n  }\n  edges {\n    node {\n      formattedDate\n      values {\n        dimensionId\n        value\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4edfe1d57cf9491fb5ba267d15e628f2";

export default node;
